import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonMainRoutingModule, routedCommonMainComponents} from './common-main-routing.module';
import {EsuvoOptionService} from '../shared/services/esuvo-option.service';
import {FilterByProfessionName} from './filter/by-profession-name.filter';
import {SharedModule} from '../shared/shared.module';
import {SortPipe} from './sort/college-profession.sort';
import {MapFilter} from './filter/map.filter';
import {NgxEchartsModule} from 'ngx-echarts';
import {NgSelectModule} from '@ng-select/ng-select';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {AppFormsModule} from '../forms/forms.module';
import {MatDialogModule, MatTooltipModule} from '@angular/material';
import {RegisterGraduateActionDialogComponent} from './components/register/register-graduate-action-dialog/register-graduate-action-dialog.component';
import {NgxEditorModule} from 'ngx-editor';
import {NgxMaskModule} from 'ngx-mask';
import {PageLayoutComponent} from './components/page-layout/page-layout.component';
import {PagesServiceShared} from './services/pages-shared.service';
import {NewsSharedService} from './services/news-shared.service';
import {EmbedVideoService} from 'ngx-embed-video';
import {PagesService} from '../moderator/services/pages.service';
import {NewsComponent} from '../user/components/news/news.component';
import {RestorePasswordModalComponent} from './components/restore-password/modal/restore-password-modal.component';
import {RestorePasswordService} from './services/restore-password.service';
import {NewsLayoutComponent} from './components/news-layout/news-layout.component';
import {CenterPositionService} from '../../common_services/dictionary-position.service';
import {CenterCollegeService} from '../../common_services/center-college.service';
import {SexService} from '../../common_services/sex.service';
import {UserInfoService} from '../user/services/user-information.service';
import {CenterOrganizationService} from '../../common_services/center-organization.service';
import {UserApplicationService} from './services/user-application.service';
import {UserApplicationDialogComponent} from './components/user-application-dialog/user-application-dialog.component';
import {UserConfirmationService} from '../user/services/user-confirmation.service';
import {CommonModeratorSharedModule} from '../shared/common-moderator-shared.module';
import {UserAuthorizationParameterService} from '../user/services/user-authorization-parameter.service';
import {CommentsBlockComponent} from './components/news-layout/comments-block/comments-block.component';
import {NewsListTabsComponent} from '../shared/components/news-list-tabs/news-list-tabs.component';
import {TechSupportFaqModalComponent} from './components/tech-support/faq-modal/tech-support-faq-modal.component';
import {NewsTagsListComponent} from '../shared/components/news-tags-list/news-tags-list.component';
import {NewsService} from '../moderator/services/news.service';
import {SearchPagesNewsComponent} from './components/search-pages-news/search-pages-news.component';
import {CollegeInfoService} from './services/college-info.service';
import {AstanaComponent} from './components/main/pages/astana/astana.component';
import {AqmolaComponent} from './components/main/pages/aqmola/aqmola.component';
import {AqtobeComponent} from './components/main/pages/aqtobe/aqtobe.component';
import {PavlodarComponent} from './components/main/pages/pavlodar/pavlodar.component';
import {AlmatyComponent} from './components/main/pages/almaty/almaty.component';
import {EnrollApplicationDialogComponent} from './components/enroll-enter/enroll-application-dialog/enroll-application-dialog.component';
import {EnrollApplicationService} from './services/enroll-application.service';
import {AlmoblComponent} from './components/main/pages/almobl/almobl.component';
import {AtyrauComponent} from './components/main/pages/atyrau/atyrau.component';
import {OralComponent} from './components/main/pages/oral/oral.component';
import {ZhambylComponent} from './components/main/pages/zhambyl/zhambyl.component';
import {KaragandaComponent} from './components/main/pages/karaganda/karaganda.component';
import {KostanayComponent} from './components/main/pages/kostanay/kostanay.component';
import {KyzylordaComponent} from './components/main/pages/kyzylorda/kyzylorda.component';
import {AqtauComponent} from './components/main/pages/aqtau/aqtau.component';
import {ShymkentComponent} from './components/main/pages/shymkent/shymkent.component';
import {PetropavlComponent} from './components/main/pages/petropavl/petropavl.component';
import {SemeyComponent} from './components/main/pages/semey/semey.component';
import {ApplyGovServicesComponent } from './components/apply-gov-services/apply-gov-services.component';
import {SscApplicationService} from '../user/services/ssc.application.service';
import { ApplyGovServiceDialogComponent } from './components/apply-gov-services/apply-gov-service-dialog/apply-gov-service-dialog.component';
import {ModuleSettingsService} from '../admin/services/module-settings.service';
import {GsLegalEntitiesService} from '../user/services/gs-legal-entities.service';
import { PublicApplicantsListComponent } from './components/public-applicants-list/public-applicants-list.component';


@NgModule({
  imports: [
    SharedModule,
    AppFormsModule,
    CommonMainRoutingModule,
    CommonModeratorSharedModule,
    NgxEchartsModule,
    NgSelectModule,
    MatTabsModule,
    MatExpansionModule,
    MatDialogModule,
    MatTooltipModule,
    NgxEditorModule,
    NgxMaskModule.forRoot()
  ],
  declarations: [
    routedCommonMainComponents,
    FilterByProfessionName,
    SortPipe,
    MapFilter,
    RegisterGraduateActionDialogComponent,
    NewsComponent,
    PageLayoutComponent,
    RestorePasswordModalComponent,
    TechSupportFaqModalComponent,
    NewsLayoutComponent,
    UserApplicationDialogComponent,
    NewsListTabsComponent,
    UserApplicationDialogComponent,
    CommentsBlockComponent,
    NewsTagsListComponent,
    SearchPagesNewsComponent,
    AstanaComponent,
    AqmolaComponent,
    AqtobeComponent,
    PavlodarComponent,
    AlmatyComponent,
    EnrollApplicationDialogComponent,
    AlmoblComponent,
    AtyrauComponent,
    OralComponent,
    ZhambylComponent,
    KaragandaComponent,
    KostanayComponent,
    KyzylordaComponent,
    AqtauComponent,
    ShymkentComponent,
    PetropavlComponent,
    SemeyComponent,
    ApplyGovServicesComponent,
    ApplyGovServiceDialogComponent,
    PublicApplicantsListComponent

  ],
  providers: [
    EsuvoOptionService,
    CollegeInfoService,
    PagesService,
    PagesServiceShared,
    NewsSharedService,
    EmbedVideoService,
    RestorePasswordService,
    CenterPositionService,
    CenterCollegeService,
    SexService,
    UserInfoService,
    UserApplicationService,
    CenterOrganizationService,
    UserConfirmationService,
    UserAuthorizationParameterService,
    NewsService,
    EnrollApplicationService,
    SscApplicationService,
    GsLegalEntitiesService,
    ModuleSettingsService
  ],
  entryComponents: [
    RegisterGraduateActionDialogComponent,
    RestorePasswordModalComponent,
    TechSupportFaqModalComponent,
    UserApplicationDialogComponent,
    EnrollApplicationDialogComponent,
    ApplyGovServicesComponent,
    ApplyGovServiceDialogComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CommonMainModule {
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/common-main.module.ts